document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.brand-nav a').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 200, // Adjust for header height if needed
          behavior: 'smooth'
        });
      }
    });
  });
});

document.addEventListener('scroll', () => {
  // Select the header element
  const header = document.querySelector('.site-header');
  const mobileheader = document.querySelector('.mobile-menu')
  
  // Add 'scrolled' class when scrolled down > 50px
  if (window.scrollY > 5) {
    header.classList.add('scrolled');
    mobileheader.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
    mobileheader.classList.remove('scrolled');
  }
});

document.addEventListener("DOMContentLoaded", () => {
  // Toggle the mobile menu
  const hamburgerButton = document.querySelector(".hamburger-menu");
  const mobileMenu = document.querySelector(".mobile-menu");

  if (hamburgerButton && mobileMenu) {
    hamburgerButton.addEventListener("click", () => {
      mobileMenu.classList.toggle("hidden");
    });
  }

  // Toggle the categories dropdown
  const categoriesButton = document.querySelector(".categories-toggle");
  const dropdownMenu = document.querySelector(".categories-dropdown");
  const mobileDropMenu = document.querySelector(".categories-dropdown-mobile");
  
  if (categoriesButton && dropdownMenu) {
    categoriesButton.addEventListener("click", () => {
      dropdownMenu.classList.toggle("hidden");
      mobileDropMenu.classList.remove("hide");
    });
  }

  const dropdownButtons = document.querySelectorAll(".dropdown")

  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('mouseleave', function(e){
      dropdownButton.classList.toggle("show")
      e.stopPropagation();
    })
  })
});